import { EnvironmentInjector, Injectable, afterNextRender } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { DriveStep, driver } from 'driver.js';

/** Etapas do tour, na ordem: alvos em ordem de preferência + chave i18n em `welcomeTour.steps`. */
const STEPS: { targets: string[]; key: string }[] = [
  // No celular (<= 960px) os itens do menu ficam escondidos: cai no botão do menu lateral.
  { targets: ['#tour-menu-garage', '#sidebarMenuBtn'], key: 'garage' },
  { targets: ['#tour-tab-vcus'], key: 'vcus' },
  { targets: ['#tour-menu-archives', '#sidebarMenuBtn'], key: 'archives' },
  { targets: ['#tour-menu-ai', '#sidebarMenuBtn'], key: 'ai' },
  { targets: ['#tour-header-actions'], key: 'account' },
];

/**
 * Tour guiado pelo menu principal (driver.js). Roda sobre /my-garage, onde o shell
 * (menu) e o dashboard (aba Minhas VCUs) estão na tela ao mesmo tempo.
 */
@Injectable({ providedIn: 'root' })
export class WelcomeTourService {
  constructor(
    private router: Router,
    private injector: EnvironmentInjector,
    private transloco: TranslocoService,
  ) {}

  /** Vai para /my-garage (se preciso) e inicia depois da renderização. */
  startFromAnywhere(): void {
    this.router.navigate(['/my-garage']).then(() => {
      afterNextRender(() => this.start(), { injector: this.injector });
    });
  }

  start(): void {
    const t = (key: string, params?: Record<string, string>) => this.transloco.translate(`welcomeTour.${key}`, params);
    const steps: DriveStep[] = STEPS.map(({ targets, key }) => ({
      // Sem alvo visível, o driver.js mostra o balão centralizado.
      element: this.firstVisible(targets),
      popover: { title: t(`steps.${key}.title`), description: t(`steps.${key}.text`) },
    }));

    driver({
      steps,
      showProgress: true,
      // O driver.js interpola {{current}}/{{total}} por conta própria; o Transloco não pode consumi-los.
      progressText: t('progress', { current: '{{current}}', total: '{{total}}' }),
      nextBtnText: t('next'),
      prevBtnText: t('prev'),
      doneBtnText: t('done'),
      popoverClass: 'ft-tour',
      // Clicar no item destacado navegaria para fora de /my-garage no meio do tour.
      disableActiveInteraction: true,
      stagePadding: 6,
      stageRadius: 4,
    }).drive();
  }

  private firstVisible(selectors: string[]): Element | undefined {
    for (const selector of selectors) {
      const el = document.querySelector<HTMLElement>(selector);
      if (el && el.getClientRects().length > 0) return el;
    }
    return undefined;
  }
}
